import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { ViewportContext } from '../viewport';

/* We used to keep the enabled/disabled logic and viewport checks inside this styled component,
 but due to the way createGlobalStyle works it caused bugs when maintaining multiple instances
 of the component in the app. It's better to avoid using props in the component and only mount
 it when we want the styles to be applied. */
const NoScrollGlobalStyle = createGlobalStyle`
&& {
  body {
    position: fixed;
    top: 0;
    overflow: hidden;
    width: 100%;
    -webkit-overflow-scrolling: touch;
  }
}
`;

type Props = {
  enabled?: boolean;
  mobile?: boolean;
  tablet?: boolean;
};

function NoScroll({ enabled = true, mobile, tablet }: Props) {
  if (!enabled) {
    return null;
  }

  // If no viewport props are set, render the styles unconditionally
  if (!mobile && !tablet) {
    return <NoScrollGlobalStyle />;
  }

  return (
    <ViewportContext.Consumer>
      {({ isMobile, isTablet }) =>
        (mobile && isMobile) || (tablet && isTablet) ? (
          <NoScrollGlobalStyle />
        ) : null
      }
    </ViewportContext.Consumer>
  );
}

export default NoScroll;
